// extracted by mini-css-extract-plugin
module.exports = {"image":"fuel-icon_image__3rWNU","disabled":"fuel-icon_disabled__XewwY"};